function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
var Play = function Play(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1,
    d: "M4.565 3.002a.6.6 0 0 0-.284.078.55.55 0 0 0-.281.487v16.515a.55.55 0 0 0 .281.487c.084.05.308.147.562 0l14.303-8.257a.55.55 0 0 0 .281-.487.55.55 0 0 0-.281-.487L4.843 3.08a.55.55 0 0 0-.278-.078m-.003 19.646c-.44 0-.88-.115-1.281-.346A2.54 2.54 0 0 1 2 20.082V3.567c0-.926.478-1.755 1.281-2.22a2.53 2.53 0 0 1 2.562 0l14.303 8.259a2.54 2.54 0 0 1 1.281 2.219 2.54 2.54 0 0 1-1.281 2.219L5.843 22.302a2.56 2.56 0 0 1-1.281.346"
  }));
};
export default Play;